import React from 'react';
import {observer} from 'mobx-react';
import {calendarDate} from 'shared/tools';
import {Modal, ModalButtons} from 'components/modals';
import {NumberInput, FormLayout, RadioButton, RadioButtonGroup} from 'components';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl';

const DayOffModal = observer(({uiState}) => {
  const {editDayOff, dayOffModalOpen} = uiState;
  if (!dayOffModalOpen) return null;

  return (
    <Modal
      isOpen={dayOffModalOpen}
      closeButton={false}
      title={calendarDate(editDayOff.date, {includeDayOfWeek: true})}
      size='sm'
      translateTitle={false}
    >
      <FormLayout>
        <RadioButtonGroup
          name='unit'
          onChange={(name, value) => editDayOff.updateUnit(value)}
          selectedValue={editDayOff.unit}>
          <RadioButton className='block pb1' disabled={editDayOff.hasHalfDayHoliday} key='full' value='full'>
            <FormattedMessage id='employees.profile.time_off.request.custom_hours.Full Day'/>
          </RadioButton>
          <RadioButton className='block pb1' key='half' value='half'>
            <FormattedMessage id='employees.profile.time_off.request.custom_hours.Half Day'/>
          </RadioButton>
          <RadioButton className='block pb1' key='custom' value='custom'>
            <FormattedMessage id='employees.profile.time_off.request.custom_hours.Custom Hours'/>
          </RadioButton>
        </RadioButtonGroup>
        {editDayOff.unit === 'custom' &&
          <NumberInput
            min={0}
            max={editDayOff.json.maxHours}
            value={editDayOff.json.cost}
            onChange={(e, valid) => editDayOff.updateHours(e.target.value, valid)}
            label='employees.profile.time_off.request.custom_hours.Hours'
            helpMessage={t('employees.profile.time_off.request.custom_hours.DAYS', {days: editDayOff.days})}
            translateHelpMessage={false}
          />
        }
      </FormLayout>
      <ModalButtons
        onSave={() => uiState.updateCustomHours()}
        onCancel={() => uiState.closeDayOffModal()}
      />
    </Modal>
  );
});

export default DayOffModal;
